import { PageController } from '@client/components/_core/layout/PageController';
import { ConnectionChecklistDrawer } from '@client/components/document-sources/ConnectionChecklistDrawer';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { parseBigintRouteParam } from '@client/utils/routing/parse-bigint-route-param';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/api-integrations/document-sources/$connectionId')({
    params: {
        parse({ connectionId }) {
            return { connectionId: parseBigintRouteParam(connectionId) };
        },
    },
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Connection',
        },
    },
    component: ConnectionRoute,
});

function ConnectionRoute() {
    const { connectionId } = Route.useParams();
    const navigate = useNavigate();

    return (
        <PageController route={Route}>
            <ConnectionChecklistDrawer
                key={String(connectionId)}
                connectionId={connectionId}
                afterClose={() => void navigate({ moveInMatches: -1 })}
            />
        </PageController>
    );
}
